'use client'
import { publicEnv } from '@/shared/config/publicEnv'

import type { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import '@/assets/styles/global.css'
import { Auth0Provider } from '@auth0/nextjs-auth0'

type Props = {
    children: ReactNode
}

if (publicEnv.mock === 'true' && publicEnv.nodeEnv === 'development') {
    void import('../mocks')
}

export default function RootLayout({ children }: Props) {
    const queryClient = new QueryClient()
    return (
        <NuqsAdapter>
            <QueryClientProvider client={queryClient}>
                <Auth0Provider>{children}</Auth0Provider>
            </QueryClientProvider>
        </NuqsAdapter>
    )
}
